import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectLabel,
    SelectTrigger,
    SelectValue,
    cn,
} from '@repo/shadcn';

type SelectFilterProps = {
    options?: Array<{ label: string; value: string }>;
    title?: string;
    placeholder?: string;
    value?: string;
    onChange?: (value: string) => void;
    className?: string;
};

export const SelectFilter = ({
    options,
    title,
    placeholder,
    value,
    onChange,
    className = '',
}: SelectFilterProps) => {
    return (
        <div className={cn(className)}>
            <Select
                defaultValue={value || ''}
                value={value || ''}
                onValueChange={onChange}
            >
                <SelectTrigger className="w-fit min-w-[150px] border border-gray-300 bg-white text-[14px] focus-visible:ring-1">
                    <SelectValue
                        placeholder={placeholder || `Select ${title}`}
                        className="text-black/75"
                    />
                </SelectTrigger>
                <SelectContent>
                    <SelectGroup>
                        {title && <SelectLabel>{title}</SelectLabel>}
                        {options?.map((option) => (
                            <SelectItem key={option.value} value={option.value}>
                                {option.label}
                            </SelectItem>
                        ))}
                    </SelectGroup>
                </SelectContent>
            </Select>
        </div>
    );
};

SelectFilter.displayName = 'SelectFilter';
